import { render, staticRenderFns } from "./SubstudyDetailsModal.vue?vue&type=template&id=66f5f537&"
import script from "./SubstudyDetailsModal.vue?vue&type=script&lang=js&"
export * from "./SubstudyDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./SubstudyDetailsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports